import { z } from 'zod';
import { refineDuration } from '../Refines';

export const ManagedRetentionSchema = z.object({
  schema: z.string(),
  catalog: z.string(),
  column: z.string().optional(),
  duration: z
    .string()
    .optional()
    .refine(...refineDuration),
});

export type ManagedRetentionSchemaValues = z.infer<
  typeof ManagedRetentionSchema
>;

export const ManagedRetentionOverrideSchema = z.object({
  table: z.string(),
  column: z.string().optional(),
  duration: z
    .string()
    .optional()
    .refine(...refineDuration),
});

export type ManagedRetentionOverrideSchemaValues = z.infer<
  typeof ManagedRetentionOverrideSchema
>;
